import { Typography } from '@care/react-component-lib';
import { Container, makeStyles } from '@material-ui/core';
import React, { FC } from 'react';
import { theme } from '@care/material-ui-theme';
import WaveDivider, {
  POSITION,
} from '@/components/pages/WelcomePage/components/WaveDivider/WaveDivider';
import useResponsive from '@/components/hooks/useResponsive';
import { AmplitudeLogger } from '@/utilities/analyticsHelper';
import { BENEFITS_COPY } from '../../data/text';
import { BENEFITS } from '../../data/benefits';
import BenefitsAccordions from '../BenefitsAccordions';
import BenefitsTabs from '../BenefitsTabs';

const { HEADER, DISCLAIMER } = BENEFITS_COPY;

export const useStyles = makeStyles(() => ({
  wrapper: {
    backgroundColor: theme.palette.care.white,
    position: 'relative',
  },
  container: {
    paddingTop: theme.spacing(7),

    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(10),
    },
  },
  headline: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(6),
      fontSize: theme.typography.serifDisplay3.fontSize,
      lineHeight: theme.typography.serifDisplay3.lineHeight,
    },
  },
  disclaimer: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
}));

interface BenefitsSectionProps {
  logger: AmplitudeLogger;
}

const BenefitsSection: FC<BenefitsSectionProps> = ({ logger }) => {
  const classes = useStyles();
  const { isDesktop } = useResponsive();

  return (
    <section data-testid="BenefitsSection" className={classes.wrapper}>
      <Container maxWidth="lg" className={classes.container}>
        <Typography variant="serifHeadline3" component="h2" className={classes.headline}>
          {HEADER}
        </Typography>

        {isDesktop ? (
          <BenefitsTabs benefits={BENEFITS} logger={logger} />
        ) : (
          <>
            <Typography variant="disclaimer2" color="secondary" className={classes.disclaimer}>
              {DISCLAIMER}
            </Typography>
            <BenefitsAccordions benefits={BENEFITS} logger={logger} />
          </>
        )}
      </Container>

      {isDesktop && (
        <WaveDivider
          position={POSITION.ABSOLUTE}
          backgroundColor="transparent"
          shapeFill={theme.palette.care.blue[100]}
        />
      )}
    </section>
  );
};

export default BenefitsSection;
